module.exports = __webpack_public_path__ + "img/Winner-6.d7a66a01.jpg";